import React, { Component } from 'react';
import { View, Link, ActionSheet } from 'core';
import { IcoDown } from 'icons';
import { theme, css } from 'constants';

const styles = css({
  btn: {
    position: 'absolute',
    top: 5,
    right: 5,
    width: 16,
    height: 16,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: theme.gray_color_alpha(0.7),
    borderRadius: 8,
    zIndex: 1
  }
});

let Tooltip = { dismiss: () => {} };
class TooltipWrapper extends Component {
  state = {};
  render() {
    const { active, is_entered } = this.state;
    const { children, style, options, onPress } = this.props;
    return (
      <View
        onMouseEnter={event => {
          this.setState({ is_entered: true });
        }}
        onClick={e => {
          !active && onPress && onPress(e);
        }}
        onMouseLeave={() => this.setState({ is_entered: false })}
        style={[style, onPress && { cursor: 'pointer' }]}
      >
        {is_entered || active ? (
          <Link
            icon_size={12}
            selected
            selected_color="white"
            style={styles.btn}
            onPress={event => {
              ActionSheet.show({
                event,
                options,
                onDismiss: () => {
                  this.setState({ active: false });
                }
              });
              this.setState({ active: true });
            }}
            icon={IcoDown}
          />
        ) : null}
        {children}
      </View>
    );
  }
}

export { Tooltip, TooltipWrapper };



// WEBPACK FOOTER //
// ./src/components/core/tooltip.web.js